import {Component, Input, OnInit} from '@angular/core'
import moment from 'moment'
import {MatIcon} from '@angular/material/icon'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatDialog} from '@angular/material/dialog'
import {MatPaginator, PageEvent} from '@angular/material/paginator'
import {AuthService} from '../../../core/services/auth/auth.service'
import {EmployeeService} from '../../../core/services/employee/employee/employee.service'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {TableListOSComponent} from '../../../shared/components/table-list-os/table-list-os.component'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatFormField, MatLabel} from '@angular/material/input'
import {MatOption, MatSelect} from '@angular/material/select'
import {
  ItemProposalCreateFormComponent
} from '../../proposal/item-proposal-create/item-proposal-create-form/item-proposal-create-form.component'
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service'
import {ContractItemService} from '../../../core/services/contract/contract-item/contract-item.service'
import {
  LogisticsContractItemCreateComponent
} from '../logistics-contract-item-create/logistics-contract-item-create.component'
import {
  ModalSugestaoAgrupamentoComponent
} from '../modal-sugestao-agrupamento/modal-sugestao-agrupamento.component'
import {StretchTypeService} from '../../../core/services/stretch/stretch-type/stretch-type.service'
import {DriverTypeService} from '../../../core/services/driver/driver-type/driver-type.service'
import {VehicleTypeService} from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {FormsModule} from '@angular/forms'
import {MatInput} from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'logistics-item-logistic',
  imports: [
    MatProgressBar,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListOSComponent,
    MatPaginator,
    MatIcon,
    MatButton,
    MatIconButton,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    MatInput,
    FormsModule,
    ItemProposalCreateFormComponent,
    MatTooltip,
  ],
  templateUrl: './logistics-item-logistic.component.html',
  styleUrl: './logistics-item-logistic.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class LogisticsItemLogisticComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private contractItemService: ContractItemService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private stretchTypeService: StretchTypeService,
    private driverTypeService: DriverTypeService,
    private vehicleTypeService: VehicleTypeService,
  ) {}

  @Input() data: any
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  orderBySelected: string = ''
  stretchTypes: any[] = []
  driverTypes: any[] = []
  vehicleTypes: any[] = []
  itemSearchForm = {
    itemPropostaId: null as number | null,
    origemCidade: '',
    origemEstado: '',
    destinoCidade: '',
    destinoEstado: '',
    tipoMotoristaId: null as number | null,
    tipoVeiculoId: null as number | null,
    tipoTrechoId: null as number | null,
    pax: null as number | null,
    dataInicio: '',
    dataFinal: '',
    nomePassageiro: '',
  }
  sorts: any[] = [
    { id: 'pax:asc', description: 'Pax' },
    { id: 'servico:asc', description: 'Serviço' },
    { id: 'origemDestinoLogistica:asc', description: 'Trecho' },
    { id: 'valor:asc', description: 'Valor' },
    { id: 'valorExtra:asc', description: 'Valor Extra' },
    { id: 'veiculo:asc', description: 'Veículo' },
  ]

  sortChange(event: any) {
    this.orderBySelected = event.value
    this.page = 1
    this.uploadList()
  }

  columns: any[] = [
    { keyColumn: 'logistica_trecho', key: '_trecho', description: 'Trecho' },
    { keyColumn: 'os_service', key: 'os_service', description: 'Serviço' },
    { keyColumn: 'os_vehicle', key: 'os_vehicle', description: 'Veículo' },
    { keyColumn: 'data_emergencial', key: 'dataInicio', description: 'Data' },
    { keyColumn: 'pax', key: 'quantidadePassageiro', description: 'PAX' },
    { keyColumn: 'hora', key: 'horaInicio', description: 'Hora' },
    { keyColumn: 'logistica_valor', key: '_valor', description: 'Valor' },
    { keyColumn: 'action', key: { itinerary: false, addPassenger: false, delete: false }, description: 'Ações' },
  ]

  screen = 'contrato item'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    this.loadSelectData()
  }

  loadSelectData() {
    this.stretchTypeService.listStretchType().subscribe({
      next: (res: any) => {
        this.stretchTypes = res.data || []
      },
      error: () => {},
    })
    this.driverTypeService.listDriverType().subscribe({
      next: (res: any) => {
        this.driverTypes = res.data || []
      },
      error: () => {},
    })
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res: any) => {
        this.vehicleTypes = res.data || []
      },
      error: () => {},
    })
  }

  performSearch() {
    this.searchForm = {
      search: true,
      model: this.buildSearchPayload(this.itemSearchForm),
    }
    this.page = 1
    this.uploadList()
  }

  clearSearch() {
    this.itemSearchForm = {
      itemPropostaId: null,
      origemCidade: '',
      origemEstado: '',
      destinoCidade: '',
      destinoEstado: '',
      tipoMotoristaId: null,
      tipoVeiculoId: null,
      tipoTrechoId: null,
      pax: null,
      dataInicio: '',
      dataFinal: '',
      nomePassageiro: '',
    }
    this.searchForm = { search: false, model: {} }
    this.page = 1
    this.uploadList()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => ele.keyColumn == 'action')
    if (index != -1) {
      this.columns[index].key = {
        itinerary: this.checkPermission('editar'),
        addPassenger: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  getSearchItems(model: any) {
    this.loading = true
    this.contractItemService.searchPagedContractItem(this.page, this.rows, model, this.orderBySelected).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
        this.loading = false
      },
      error: () => {
        this.snackbar.error('Não foi possível listar os itens de logística.')
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  buildSearchPayload(form: any) {
    return {
      itemPropostaId: form.itemPropostaId || 0,
      origemId: 0,
      descricaoOrigem: '',
      origemCidade: form.origemCidade || '',
      origemEstado: form.origemEstado || '',
      destinoId: 0,
      descricaoDestino: '',
      destinoCidade: form.destinoCidade || '',
      destinoEstado: form.destinoEstado || '',
      tipoServicoId: 0,
      descricaoTipoServico: '',
      servicoId: 0,
      descricaoServico: '',
      propostaId: this.data.propostaId || 0,
      tipoMotoristaId: form.tipoMotoristaId || 0,
      tipoVeiculoId: form.tipoVeiculoId || 0,
      contratoId: this.data.id,
      pax: form.pax || 0,
      dataInicio: form.dataInicio || '',
      dataFinal: form.dataFinal || '',
      tipoTrechoId: form.tipoTrechoId || 0,
      nomePassageiro: form.nomePassageiro || '',
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getListItems()
    }
  }

  private defaultPayload() {
    return {
      itemPropostaId: 0,
      origemId: 0,
      descricaoOrigem: '',
      origemCidade: '',
      origemEstado: '',
      destinoId: 0,
      descricaoDestino: '',
      destinoCidade: '',
      destinoEstado: '',
      tipoServicoId: 0,
      descricaoTipoServico: '',
      servicoId: 0,
      descricaoServico: '',
      propostaId: this.data.propostaId || 0,
      tipoMotoristaId: 0,
      tipoVeiculoId: 0,
      contratoId: this.data.id,
      pax: 0,
      dataInicio: '',
      dataFinal: '',
      tipoTrechoId: 0,
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        const paisO = item.paisOrigem ? ` (${item.paisOrigem})` : ''
        const paisD = item.paisDestino ? ` (${item.paisDestino})` : ''
        list.push({
          ...item,
          tipoServico: item.tipoServicoDescricao || '-',
          servico: item.serfvicoDescricao || item.servicoDescricao || '-',
          nomeTipoVeiculo: item.tipoVeiculoDescricao || '-',
          nomeTipoMotorista: item.tipoMotoristaDescricao || '-',
          _trecho: `Origem\nCidade: ${item.cidadeOrigem || '-'}\nEstado: ${item.estadoOrigem || '-'}${paisO}\nDestino\nCidade: ${item.cidadeDestino || '-'}\nEstado: ${item.estadoDestino || '-'}${paisD}`,
          _horarios: `Início: ${item.horaInicio?.substring(0, 5) || '-'}\nFim: ${item.horaFinal?.substring(0, 5) || '-'}`,
          _valor: `Valor: R$ ${this.formatCurrency(item.valorProposta)}\nC. Taxa: R$ ${this.formatCurrency(item.valorComTaxa)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  private formatCurrency(value: any): string {
    if (value == null) return '-'
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return '-'
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  getListItems() {
    this.loading = true
    this.contractItemService
      .searchPagedContractItem(this.page, this.rows, this.defaultPayload(), this.orderBySelected)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: () => {
          this.snackbar.error('Não foi possível listar os itens de logística.')
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      data: {
        edit: true,
        item: item,
        idClient: this.data.idCliente,
        period: {
          dataInicio: this.data.dataInicio,
          dataFim: this.data.dataFim,
        },
      },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.loading = true
        const model = {
          ...this.mapToExpectedModel(response),
          id: item.id,
          itemPropostaId: item.itemPropostaId ?? null,
        }
        this.contractItemService.editContractItem(model).subscribe({
          next: () => {
            this.snackbar.success('Item de logística atualizado com sucesso!')
            this.uploadList()
          },
          error: (err) => {
            console.error(err)
            this.snackbar.error('Não foi possível atualizar o item de logística.')
            this.loading = false
          },
        })
      }
    })
  }

  deleteItem(item: any) {
    if (confirm('Deseja realmente excluir este item?')) {
      this.loading = true
      this.contractItemService.deleteContractItem({ id: item.id, descricao: '' }).subscribe({
        next: () => {
          this.snackbar.success('Item de logística excluído com sucesso!')
          this.uploadList()
        },
        error: (err) => {
          console.error(err)
          this.snackbar.error('Não foi possível excluir o item de logística.')
          this.loading = false
        },
      })
    }
  }

  openItinerary(item: any) {
    // TODO: abrir modal de itinerário do item
    console.log('itinerário do item:', item)
  }

  openPassengers(item: any) {
    // TODO: abrir modal de passageiros do item
    console.log('passageiros do item:', item)
  }

  openSugestaoAgrupamento() {
    const dialogRef = this.dialog.open(ModalSugestaoAgrupamentoComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: this.data,
    })
    dialogRef.afterClosed().subscribe((response) => {
        this.uploadList()
    })
  }

  addItem() {
    const dialogRef = this.dialog.open(LogisticsContractItemCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: this.data,
    })

    dialogRef.componentInstance.response.subscribe((success: boolean) => {
      if (success) {
        this.uploadList()
      }
    })
  }

  mapToExpectedModel(response: any) {
    const passageiro: any[] = []
    return {
      contratoId: Number(this.data.id),
      itemPropostaId: response.itemPropostaId != null ? parseInt(response.itemPropostaId, 10) : null,
      tipoMotoristaId: response.tipoMotoristaId != null ? Number(response.tipoMotoristaId) : null,
      tipoVeiculoId: response.tipoVeiculoId != null ? Number(response.tipoVeiculoId) : null,
      origemId: Number(response.origemId) || 0,
      destinoId: Number(response.destinoId) || 0,
      tipoServicoId: response.tipoServicoId != null ? Number(response.tipoServicoId) : null,
      servicoId: response.servicoId != null ? Number(response.servicoId) : null,
      dataInicio: response.dataInicio
        ? moment(response.dataInicio, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
        : null,
      horaInicio: this.toHHMMSS(response.horaInicio || ''),
      dataFinal: response.dataFinal
        ? moment(response.dataFinal, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
        : null,
      horaFinal: this.toHHMMSS(response.horaFinal || ''),
      valorTarifario: null,
      valorProposta: this.parseVal(response.vendaSemTaxa),
      valorCompra: null,
      tipoTrechoId: response.tipoTrechoId != null ? Number(response.tipoTrechoId) : null,
      kmPrevisto: parseFloat(response.kmPrevisto) || 0,
      tempoPrevisto: response.tempoPrevisto || '0:00:00',
      observacao: response.observacao || '',
      passageiro,
      temPassageiro: passageiro.length > 0 ? 'S' : 'N',
      itinerario: (response.intinerarios || []).map((iti: any) => ({
        contratoItemId: '00000000-0000-0000-0000-000000000000',
        localParada: iti.localParada || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: iti.complemento || '',
        descricao: iti.descricao || '',
        cidade: iti.cidade || '',
        estado: iti.estado || '',
        latitude: iti.latitude || 0,
        longitude: iti.longitude || 0,
        trecho: iti.trecho || '',
        areaTarifario: iti.areaTarifario || 'N',
      })),
    }
  }

  private toHHMMSS(hora: string): string {
    if (!hora) return '00:00:00'
    const parts = hora.split(':')
    return parts.length === 3 ? hora : `${hora}:00`
  }

  private parseVal(value: any): number {
    if (typeof value === 'number') return value
    if (typeof value === 'string') {
      const n = parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
      return isNaN(n) ? 0 : n
    }
    return 0
  }
}
